'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _jss = require('jss');

var _jss2 = _interopRequireDefault(_jss);

var _ramda = require('ramda');

var _jssNested = require('jss-nested');

var _jssNested2 = _interopRequireDefault(_jssNested);

var _button = require('./button.css');

var _button2 = _interopRequireDefault(_button);

var _inflIcons = require('infl-icons');

var _gild = require('gild');

var _theme = require('./theme');

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_jss2.default.use((0, _jssNested2.default)());

var clean = (0, _ramda.omit)(['icon', 'type', 'inverse', 'style', 'classList', 'theme', 'iconClass']);

var Button = exports.Button = function (_Component) {
  _inherits(Button, _Component);

  function Button() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Button);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Button.__proto__ || Object.getPrototypeOf(Button)).call.apply(_ref, [this].concat(args))), _this), _this._getClasses = function () {
      var _this$props = _this.props,
          classList = _this$props.classList,
          type = _this$props.type,
          theme = _this$props.theme;


      return (0, _classnames2.default)(_button2.default[_this._determineButtonClass()], classList, theme[type]);
    }, _this._determineButtonClass = function () {
      var _this$props2 = _this.props,
          disabled = _this$props2.disabled,
          inverse = _this$props2.inverse,
          type = _this$props2.type;


      if (disabled) return 'disabled';

      if ((type === 'secondary' || type === 'text') && inverse) {
        return type + 'Inverse';
      }

      return type;
    }, _this._hasIcon = function () {
      if (_this.props.icon === '') return null;

      return _react2.default.createElement(
        'span',
        { className: (0, _classnames2.default)(_button2.default.icon, _this.props.iconClass) },
        _react2.default.createElement(_inflIcons.Icon, { icon: _this.props.icon })
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Button, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          disabled = _props.disabled,
          onClick = _props.onClick,
          children = _props.children,
          isSubmit = _props.isSubmit,
          rest = _objectWithoutProperties(_props, ['disabled', 'onClick', 'children', 'isSubmit']);

      return _react2.default.createElement(
        'button',
        _extends({ type: isSubmit ? 'submit' : 'button',
          disabled: disabled,
          onClick: onClick
        }, clean(rest), {
          className: this._getClasses() }),
        this._hasIcon(),
        children
      );
    }
  }]);

  return Button;
}(_react.Component);

Button.propTypes = {
  icon: _propTypes2.default.string,
  type: _propTypes2.default.oneOf(['primary', 'secondary', 'important', 'success', 'danger', 'text', 'default']),
  onClick: _propTypes2.default.func,
  disabled: _propTypes2.default.bool,
  inverse: _propTypes2.default.bool,
  isSubmit: _propTypes2.default.bool,
  style: _propTypes2.default.object,
  classList: _propTypes2.default.string,
  theme: _propTypes2.default.object,
  iconClass: _propTypes2.default.string
};
Button.defaultProps = {
  icon: '',
  disabled: false,
  inverse: false,
  isSubmit: false,
  classList: null,
  theme: {},
  type: 'default',
  iconClass: ''
};
exports.default = (0, _gild.connectTheme)(_theme2.default)(Button);